import type { FC } from "preact/compat";
import { cva } from "class-variance-authority";
import type { ButtonProps } from "./interfaces";
import cn from "classnames";

export const buttonVariants = cva(
    "flex cursor-pointer select-none items-center rounded-3xl border fill-current px-4 py-1 outline-none transition duration-100 focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none",
    {
        variants: {
            variant: {
                primary:
                    "border-sky-800 bg-sky-800 text-white hover:border-sky-900 hover:bg-sky-900 focus:ring-sky-500 disabled:border-gray-500 disabled:bg-gray-500 disabled:text-gray-100",
                secondary:
                    "border-gray-300 bg-white hover:border-sky-500 hover:text-sky-500 focus:ring-sky-500 disabled:text-gray-400",
                ghost: "border-gray-300 hover:border-sky-500 hover:text-sky-500 focus:ring-sky-500 disabled:text-gray-400",
                success:
                    "border-lime-600 bg-lime-600 text-white hover:border-lime-700 hover:bg-lime-700 focus:ring-lime-800 disabled:border-gray-500 disabled:bg-gray-500 disabled:text-gray-100",
                danger: "border-red-600 bg-red-600 text-white hover:border-red-800 focus:ring-red-700 disabled:border-gray-500 disabled:bg-gray-500 disabled:text-gray-100",
                "danger-ghost":
                    "border-red-500 text-red-500 hover:border-red-700 hover:text-red-700 focus:ring-red-700 disabled:border-gray-300 disabled:text-gray-400",
            },
            size: {
                sm: "text-sm",
                md: "",
            },
        },
        defaultVariants: {
            variant: "ghost",
            size: "md",
        },
    },
);

const Button: FC<ButtonProps> = ({
    className,
    children,
    variant,
    size,
    as = "button",
    type = "button",
    ...rest
}) => {
    const Component = as === "a" ? "a" : as === "label" ? "label" : "button";

    return (
        <Component
            type={as === "button" ? type : undefined}
            className={cn(buttonVariants({ variant, size, className }))}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            {...(rest as any)}
        >
            {children}
        </Component>
    );
};

export default Button;
